import { render, staticRenderFns } from "./ElementUploadImg.vue?vue&type=template&id=4477f090&"
import script from "./ElementUploadImg.vue?vue&type=script&lang=js&"
export * from "./ElementUploadImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports